import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Icon,
  Text as ChakraText,
} from '@chakra-ui/react'
import { noop } from 'lodash'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { RiDeleteBinLine } from 'react-icons/ri'
import { colors } from '../../../../ui-kit'

interface Props {
  isOpen: boolean
  isDeleting: boolean
  tagName?: () => void
  closeDeleteDialog(): void
  deleteClientTag(): void
}

const DeleteDialog = ({
  isOpen,
  isDeleting,
  tagName,
  closeDeleteDialog,
  deleteClientTag,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const cancelRef = useRef(null)

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={closeDeleteDialog}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="xl" fontWeight="semibold">
            <Icon
              as={RiDeleteBinLine}
              color="appBattleshipGrey"
              backgroundColor="appPaleGrey"
              boxSize={6}
              padding="0.1em"
              borderRadius="full"
              marginRight="0.5em"
            />
            {t('delete_tag', 'Delete tag')}
          </AlertDialogHeader>

          <AlertDialogCloseButton mr={0} />

          <AlertDialogBody color="appBattleshipGrey">
            <ChakraText fontWeight="semibold" marginBottom={2} fontSize="md">
              {t(
                'suggested_tag_delete_disclaimer',
                'Existing tags in files are not removed. It just removes previously used tag suggestions.',
              )}
            </ChakraText>
            {t('are_you_sure_delete_parametrized', {
              entityName: tagName ? tagName() : '',
            })}
          </AlertDialogBody>

          <AlertDialogFooter
            borderTop="1px solid #f2f2f4"
            style={{ gap: '1em' }}
          >
            <Button
              ref={cancelRef}
              variant="outline"
              onClick={closeDeleteDialog}
            >
              {t('cancel', 'Cancel')}
            </Button>
            <Button
              isLoading={isDeleting}
              loadingText={t('deleting', 'Deleting')}
              colorScheme={colors.appRed}
              onClick={async () => {
                try {
                  await deleteClientTag()
                  closeDeleteDialog()
                } catch (err) {
                  noop()
                }
              }}
            >
              {t('delete', 'Delete')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export default DeleteDialog
